import React, { useEffect, useReducer } from 'react';
import { toast } from 'react-hot-toast';
import AOS from 'aos';
import 'aos/dist/aos.css';
import { FiPhoneCall } from 'react-icons/fi';
import { ImLocation2 } from 'react-icons/im';
import { HiOutlineMail } from 'react-icons/hi';
import './ContactMe.css'
import useTitle from '../../Hooks/useTitle';
import { useLocation } from 'react-router-dom';
import { useLanguage } from '../../context/LanguageContext';













const ContactMe = () => {


    useTitle('Contact | Fahim Faysal');
    const { pathname } = useLocation();



    const handleFormSubmit = (event) => {
        event.preventDefault();
        const name = event.target.name.value;
        const email = event.target.email.value;
        const message = event.target.message.value;
        console.log(name, email, message);
        toast.success('Message Sent Successfully');
        event.target.reset();

    }


    useEffect(() => {
        AOS.init({
            duration: 1500
        })
    }, [])



    const initialState = {
        name: "",
        email: "",
        message: "",
        term: false,
        count: 0,
    }
    const reducer = (state, action) => {

        // if (action.type === 'INPUT') {
        //     return {
        //         ...state,
        //         [action.payload.name]: action.payload.value
        //     }
        // }

        switch (action.type) {
            case "INPUT":
                return {
                    ...state,
                    [action.payload.name]: action.payload.value
                };

            case "CHECK":
                return {
                    ...state,
                    term: !state.term
                };

            case "INCREASE":
                return {
                    ...state,
                    count: state.count + 1
                };

            case "DECREASE":
                return {
                    ...state,
                    count: state.count - 1
                };

            default:
                return state
        }

    }

    //ei line ta shobar niche likhte hobe. Otherwise kaj korbe na.. error dibe
    const [state, dispatch] = useReducer(reducer, initialState);

    const handleAgainFormSubmit = (event) => {
        event.preventDefault();
        console.log("State Values: ", state);
        console.log("Type Of State: ", typeof (state));
    }



    const { language } = useLanguage();








    return (
        <div className="">
            {
                language === 'english' ?
                    <>
                        <h1 id='contact' className={`uppercase mb-12 text-center text-3xl sm:text-3xl md:text-4xl lg:text-5xl font-mono ${pathname.includes('contact') ? 'sm:mt-10 md:mt-36 mt-32' : 'sm:mt-4 md:mt-0 mt-4'}`}>Contact <span className='text-rose-600 text-6xl'>Me</span>
                            {/* <hr className='mx-auto mt-2 ' width="200px" /> */}
                            <div className=' lg:mt-1 md:mt-3 mt-3  text-center lg:w-[280px] md:w-[260px] sm:w-[240px] w-[240px] h-[70px]       wavy'></div>
                        </h1>
                    </>
                    :
                    <>
                        <h1 id='contact' className={`uppercase mb-12 text-center text-3xl sm:text-3xl md:text-4xl lg:text-5xl font-mono ${pathname.includes('contact') ? 'sm:mt-10 md:mt-36 mt-32' : 'sm:mt-4 md:mt-0 mt-4'}`}>যোগাযোগ  <span className='text-rose-600 text-6xl'>করুন</span>
                            {/* <hr className='mx-auto mt-2 ' width="200px" /> */}
                            <div className=' lg:mt-1 md:mt-3 mt-3  text-center lg:w-[280px] md:w-[260px] sm:w-[240px] w-[240px] h-[70px]       wavy'></div>
                        </h1>
                    </>
            }

            
            
            
            
            <div className='lg:px-[40px] md:px-6 px-2 flex justify-evenly gap-x-6 lg:flex-row md:flex-col sm:flex-col flex-col '>


                <div className='w-full sm:w-full md:w-3/4 lg:w-1/2 lg:mx-0 md:mx-auto sm:mx-auto mx-auto backdrop-blur-md myContact text-slate-300'>
                    <h1 className='text-2xl text-center mb-4 mt-8'>{language === 'english' ? 'Contact' : 'যোগাযোগের'} <span className='text-rose-700 text-4xl font-semibold'>{language === 'english' ? 'Info' : 'তথ্য'}</span></h1>
                    {
                        language === 'english' ?
                            <>
                                <p className='text-xl px-6 md:px-6 sm:px-5 lg:px-8 text-justify'>These are my personal details. If you have any queries or want to know more about me then please don't hesitate to call me. You can also connect with me by my social media profiles. You can contact me via email also. If you like my works, please sent your valuable feedbacks via email. It will be appreciated</p>
                            </>
                            :
                            <>
                                <p className='text-xl px-6 md:px-6 sm:px-5 lg:px-8 text-justify'>আপনার যদি কোন প্রশ্ন থাকে বা আমার সম্পর্কে আরও জানতে চান তাহলে দয়া করে আমাকে কল করতে দ্বিধা করবেন না। আপনি আমার সামাজিক মিডিয়া প্রোফাইল দ্বারা আমার সাথে যোগাযোগ করতে পারেন। আপনি ইমেইলের মাধ্যমেও আমার সাথে যোগাযোগ করতে পারেন। আপনি যদি আমার কাজ পছন্দ করেন, অনুগ্রহ করে ইমেল মাধ্যমে আপনার মূল্যবান মতামত পাঠান।</p>
                            </>
                    }
                    <div className='text-center mt-8'>
                        <div className='flex justify-center gap-x-3 items-center my-4'>
                            <FiPhoneCall className='text-xl'></FiPhoneCall>
                            {
                                language === 'english' ?
                                    <p className='text-start text-xl'>Mobile: +8801870203220</p>
                                    :
                                    <p className='text-start text-xl'>ফোন: +৮৮০১৮৭০২০৩২২০</p>
                            }
                        </div>
                        <div className='flex justify-center gap-x-3 items-center my-4'>
                            <ImLocation2 className='text-xl'></ImLocation2>
                            {
                                language === 'english' ?
                                    <p className='text-start text-xl'>Address: Dhanmondi, Dhaka</p>
                                    :
                                    <p className='text-start text-xl'>ঠিকানা: ধানমন্ডি, ঢাকা</p>
                            }
                        </div>
                        <div className='flex justify-center gap-x-3 items-center my-4'>
                            <HiOutlineMail className='text-2xl'></HiOutlineMail>
                            {
                                language === 'english' ?
                                    <p className='text-start text-xl'>Email: fahim.sakib.10@gmail.com</p>
                                    :
                                    <p className='text-start text-xl'>ইমেইল: fahim.sakib.10@gmail.com</p>
                            }
                        </div>
                    </div>
                </div>


                
                
                
                
                <div className="divider lg:divider-horizontal my-8"></div>

                <div className='lg:w-1/2 md:w-[620px] sm:w-full w-full lg:mx-auto md:mx-auto  sm:px-2 px-2 md:px-6 py-4 rounded-xl mb-16 border-cyan-600 border-b-2 border-t-0 border-r-2 border-l-0 glass animation' data-aos='zoom-in'>
                    <form
                        action='https://formspree.io/f/xzbwnkow'
                        method='POST'
                        className='lg:mx-0 md:mx-0 sm:mx-4 mx-4 '>
                        <div>
                            <label className="label">
                                <span className="label-text text-white">{language === 'english' ? 'Name' : 'নাম'}</span>
                            </label>
                            <input
                                type="text" name='name' className="input input-bordered w-full mb-1 font-semibold bg-white text-black" placeholder={language === 'english' ? 'Your Name' : 'আপনার নাম'} required
                            />
                        </div>
                        <div>
                            <label className="label">
                                <span className="label-text text-white">{language === 'english' ? 'Email' : 'ইমেইল'}</span>
                            </label>
                            <input
                                type="email" name='email' className="input input-bordered w-full mb-1 font-semibold bg-white text-black" placeholder={language === 'english' ? 'Your Email' : 'আপনার ইমেইল'} required
                            />
                        </div>
                        <div>
                            <label className="label">
                                <span className="label-text text-white">{language === 'english' ? 'Message' : 'বার্তা'}</span>
                            </label>
                            <textarea
                                name='message'
                                className="textarea textarea-bordered w-full h-24 mt-1 bg-white text-black font-semibold" placeholder={language === 'english' ? 'Write Your Message' : 'আপনার বার্তা লিখুন'} required></textarea>
                        </div>
                        <div className='relative group mt-4 mb-2' >
                            <div className='absolute -inset-0.5 mt-4 rounded-xl blur bg-gradient-to-r from-pink-600 to-violet-400 opacity-70 group-hover:opacity-90 transition duration-300 '>

                            </div>
                            <button type='submit' value="Submit" className='w-full py-4 text-center text-white text-2xl mt-4 bg-black rounded-xl leading-none relative transition duration-300 ease-in-out delay-150 group-hover:-translate-y-0.5 group-hover:scale-102 '>
                                <div className='flex space-x-3 justify-center items-center'>
                                    <span>{language === 'english' ? 'Send Message' : 'বার্তা পাঠান'}</span>
                                </div>
                            </button>
                        </div>
                    </form>
                </div>


            </div>












            {/* <div className='mt-28 flex justify-evenly gap-x-6 lg:flex-row md:flex-col sm:flex-col flex-col '>

                <div className='bg-gray-800 lg:w-3/4 md:w-[620px] sm:w-full w-full lg:mx-auto md:mx-auto  sm:px-2 px-2 md:px-6 py-4 rounded-xl mb-16 border-cyan-600 border-b-2 border-t-0 border-r-2 border-l-0'>

                    
                    <h1 className='md:text-2xl text-xl text-center text-white mt-2 mb-3'>Form State Management With useReducer Hook</h1>
                    
                    <form
                        onSubmit={handleAgainFormSubmit}
                        className='lg:mx-0 md:mx-0 sm:mx-4 mx-4 '>

                        <div>
                            <label className="label">
                                <span className="label-text text-white">Name</span>
                            </label>
                            <input
                                type="text" name='name' className="input input-bordered w-full my-2 font-semibold bg-white text-black" placeholder='Your Name'
                                onChange={(e) => dispatch({ type: 'INPUT', payload: { name: e.target.name, value: e.target.value } })}
                            />
                        </div>

                        <div>
                            <label className="label">
                                <span className="label-text text-white">Email</span>
                            </label>
                            <input
                                type="email" name='email' className="input input-bordered w-full my-2 font-semibold bg-white text-black" placeholder='Your Email'
                                onChange={(e) => dispatch({ type: 'INPUT', payload: { name: e.target.name, value: e.target.value } })}
                            />
                        </div>

                        <div>
                            <textarea
                                name='message'
                                className="textarea textarea-bordered w-full h-24 mt-4 bg-white text-black" placeholder="Write Message"
                                onChange={(e) => dispatch({ type: 'INPUT', payload: { name: e.target.name, value: e.target.value } })}>

                            </textarea>
                        </div>



                        <div className='mt-6 flex  justify-between items-center'>

                            <div
                                onClick={() => dispatch({ type: 'DECREASE' })}

                                className='cursor-pointer bg-orange-600 text-white lg:px-6 md:px-3 px-2 py-2 md:text-xl md:text-md text-sm rounded-sm'>
                                Decrease
                            </div>

                            <div className=" bg-white  lg:px-72 md:px-32 px-12 md:py-2 py-1 rounded-sm">
                                <span className='text-center md:text-xl text-md   text-black'>{state.count}</span>
                            </div>

                            <div
                                onClick={() => dispatch({ type: 'INCREASE' })}
                                className='cursor-pointer bg-orange-600 text-white lg:px-6 md:px-3 px-2 py-2 md:text-xl md:text-md text-sm rounded-sm'>
                                Increase
                            </div>

                        </div>


                        <div className='flex items-center gap-x-2 mt-6 text-sm'>
                            <input
                                onClick={() => dispatch({ type: 'CHECK' })}
                                type="checkbox" name='term' className="rounded-sm checkbox border-2 border-white" />
                            <p className='font-semibold text-white'> I agree with all the Terms And Conditions</p>
                        </div>

                        <div className='mt-2 mb-2' >
                            <button
                            disabled={!state.term}
                            type='submit' value="Submit" className={`scale-95 mt-6 w-full py-2 text-center text-white text-xl ${!state.term ? 'bg-gray-600' : 'bg-blue-800 transition duration-300 ease-in-out hover:scale-100 '}`}>
                                <div className='flex space-x-3 justify-center items-center'>
                                    <span>Submit</span>
                                </div>
                            </button>
                        </div>

                    </form>
                </div>


            </div> */}







        </div >
    );
};

export default ContactMe;